import * as React from 'react';
import { Box, TextInput, Group, Button, NumberInput, PasswordInput, Select } from '@mantine/core'
import  { useForm, isNotEmpty, isEmail } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE, UserRoleCode, roleCodes } from "./constants";
import { showMessage } from "../../lib/notification";
import { IconChevronDown } from "@tabler/icons-react";
import { IMAGE_MIME_TYPE } from "@mantine/dropzone";
import FileUpload from "../../components/file-upload";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";
import { assignFiles } from "../../utils/form";

interface FormValues {
    email: string;
    password: string;
    name: string;
    phoneNumber: string;
    profilePicture: File | null;
    roleCode: UserRoleCode[];
}

interface IParams extends Omit<FormValues, 'profilePicture'> {
    profilePicture?: string;
}

const CreateUser = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            email: '',
            password: '',
            name: '',
            phoneNumber: '',
            profilePicture: null,
            roleCode: [],
        },

        validate: {
            email: isEmail('Имэйл буруу байна'),
            password: isNotEmpty('Нууц үг оруулна уу'),
            name: isNotEmpty('Нэр оруулна уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const files = await assignFiles({
            profilePicture: values.profilePicture
        }, 'user')
        const params: IParams = {
            ...values,
            ...files,
        }

        const { data } = await axios.post<IResponse<any>>(API_ROUTE, params);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Имэйл"
                            placeholder="Имэйл оруулна уу"
                            {...form.getInputProps('email')}
                        />

                        <PasswordInput
                            withAsterisk
                            autoComplete='off'
                            label="Нууц үг"
                            placeholder="Нууц үг оруулна уу"
                            {...form.getInputProps('password')}
                        />

                        <TextInput
                            withAsterisk
                            label="Нэр"
                            placeholder="Нэр оруулна уу"
                            {...form.getInputProps('name')}
                        />

                        <NumberInput
                            hideControls
                            label="Утасны дугаар"
                            placeholder="Утасны дугаар оруулна уу"
                            {...form.getInputProps('phoneNumber')}
                        />

                        <FileUpload
                            value={form.values.profilePicture}
                            onChange={(value) => {
                                form.setFieldValue('profilePicture', value);
                            }}
                            label='Профайл зураг'
                            accept={IMAGE_MIME_TYPE}
                        />

                        <Select
                            label="Роль код"
                            rightSection={<IconChevronDown size={14} />}
                            rightSectionWidth={30}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={roleCodes}
                            {...form.getInputProps('roleCode')}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default CreateUser;